<template>
  <div class="survivor-pick" :class="pick.state">
    {{ pick.team }}
    <i v-if="pick.state === 'win'" class="material-icons tick">
      check_circle
    </i>
    <i v-if="pick.state === 'loss'" class="material-icons cross">
      cancel
    </i>
  </div>
</template>

<script>
export default {
  name: 'SurvivorPick',
  props: {
    pick: Object
  }
}
</script>

<style scoped>
  .survivor-pick {
    background-color: #7f8c8d;
    border-radius: .25em;
    color: white;
    display: inline-block;
    font-weight: 600;
    margin: 0 .5em .5em 0;
    padding: .25em .5em;
  }

  .material-icons {
    font-size: 1em;
    position: relative;
    top: -1.5px;
    vertical-align: middle;
  }

  .win { background-color: #27ae60; }
  .loss { background-color: #c0392b; }
</style>
